import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Download({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.3333 1.33331V13.0572L8.47136 10.1952L7.52855 11.1381L11.5286 15.1381C11.7889 15.3984 12.211 15.3984 12.4714 15.1381L16.4714 11.1381L15.5286 10.1952L12.6666 13.0572V1.33331H11.3333Z"
        fill={iconColor}
      />
      <Path
        d="M3.99996 7.33331C3.99996 6.96512 4.29844 6.66665 4.66663 6.66665H9.33329V5.33331H4.66663C3.56206 5.33331 2.66663 6.22874 2.66663 7.33331V18C2.66663 19.1045 3.56206 20 4.66663 20H19.3333C20.4379 20 21.3333 19.1045 21.3333 18V7.33331C21.3333 6.22874 20.4379 5.33331 19.3333 5.33331H14.6666V6.66665H19.3333C19.7015 6.66665 20 6.96512 20 7.33331V18C20 18.3682 19.7015 18.6666 19.3333 18.6666H4.66663C4.29844 18.6666 3.99996 18.3682 3.99996 18V7.33331Z"
        fill={iconColor}
      />
    </Svg>
  );
}
